import { useEffect, useLayoutEffect } from 'react';
import { Outlet, ScrollRestoration, useLocation } from 'react-router-dom';
import { trackPageView } from '../../utils/analytics';

export default function RootLayout() {
  const location = useLocation();
  const { pathname, search } = location;

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  // Track landings + SPA navigations in Google Analytics
  useEffect(() => {
    trackPageView(pathname + search);
  }, [pathname, search]);

  return (
    <>
      <Outlet />
      <ScrollRestoration />
    </>
  );
}
